// src/components/user/authentication/RegisterForm.jsx
import React, { useContext, useState } from "react";
import { FaGoogle, FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FiEye, FiEyeOff } from "react-icons/fi";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../../context/AppContext";

const RegisterForm = ({ onRegisterSuccess }) => {
  const navigate = useNavigate();
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errormessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { baseUrl, regExpChecker } = useContext(AppContext);

  // 👇 yeh 4 naye states, existing states ke sath hi rakhein
  const [otpStep, setOtpStep] = useState(false);
  const [otp, setOtp] = useState("");
  const [pendingEmail, setPendingEmail] = useState("");
  const [pendingPassword, setPendingPassword] = useState("");
  const [verifying, setVerifying] = useState(false);

  // 👇 purana handleSubmit isse replace karein
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!fullname || !email || !password || !confirmPassword) {
      setErrorMessage("Please fill all fields");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }
    if (errormessage) return;

    const formdata = new FormData();
    formdata.append("fullname", fullname);
    formdata.append("email", email);
    formdata.append("password", password);

    axios.post(`${baseUrl}/customer/signup`, formdata)
      .then(() => {
        setPendingEmail(email);
        setPendingPassword(password);
        setOtpStep(true);
        setErrorMessage("");
      })
      .catch((error) => {
        const validationErrors = error.response?.data?.errors;
        if (validationErrors) {
          setErrorMessage(Object.values(validationErrors)[0][0]);
        } else {
          setErrorMessage(error.response?.data?.error || "Registration failed");
        }
      });
  };

  // 👇 yeh naya function, handleSubmit ke bilkul niche add karein
  const handleVerifyOtp = () => {
    if (!otp) {
      setErrorMessage("Please enter the OTP");
      return;
    }

    // 👇 Double-click / duplicate request rokne ke liye — warna do requests
    // ek sath jati hain aur backend par "Duplicate entry" error aata hai
    if (verifying) return;
    setVerifying(true);

    const formdata = new FormData();
    formdata.append("email", pendingEmail);
    formdata.append("otp", otp);

    axios.post(`${baseUrl}/customer/verify-registration-otp`, formdata)
      .then(() => {
        onRegisterSuccess
          ? onRegisterSuccess(pendingEmail, pendingPassword)
          : navigate("/auth", { state: { isLogin: true } });
      })
      .catch((error) => {
        setErrorMessage(error.response?.data?.error || "OTP verification failed");
      })
      .finally(() => {
        setVerifying(false);
      });
  };

  const handleSocialRegister = (provider) => {
    console.log(`Register with ${provider}`);
  };

  // 👇 return / JSX yahan replace hoga — do steps mein dikhega
  return (
    <>
      {!otpStep ? (
        <>
          <h3>Create Account</h3>

          <input
            type="text"
            placeholder="Full Name"
            value={fullname}
            onChange={(event) => {
              setFullname(event.target.value);
              setErrorMessage(regExpChecker("username", event.target.value))
            }}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value)
              setErrorMessage(regExpChecker("email", event.target.value))
            }}
          />

          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              style={{ width: "100%", paddingRight: "40px" }}
              onChange={(event) => {
                setPassword(event.target.value)
                setErrorMessage(regExpChecker("password", event.target.value))
              }}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute", right: "12px", top: "50%",
                transform: "translateY(-50%)", cursor: "pointer", color: "#888",
              }}
            >
              {showPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </span>
          </div>

          <div style={{ position: "relative" }}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              value={confirmPassword}
              style={{ width: "100%", paddingRight: "40px" }}
              onChange={(e) => {
                const value = e.target.value;
                setConfirmPassword(value);
                if (value !== password) {
                  setErrorMessage("Passwords do not match");
                } else {
                  setErrorMessage("");
                }
              }}
            />
            <span
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              style={{
                position: "absolute", right: "12px", top: "50%",
                transform: "translateY(-50%)", cursor: "pointer", color: "#888",
              }}
            >
              {showConfirmPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
            </span>
          </div>

          {errormessage && <p style={{ color: "red" }}> {errormessage}</p>}

          <button className="main-btn" onClick={handleSubmit}>Register</button>
        </>
      ) : (
        <>
          <h3>Verify Your Email</h3>
          <p style={{ fontSize: "14px", color: "#555" }}>
            We sent a 6-digit code to <b>{pendingEmail}</b>
          </p>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
          />
          {errormessage && <p style={{ color: "red" }}> {errormessage}</p>}
          <button className="main-btn" onClick={handleVerifyOtp} disabled={verifying}>
            {verifying ? "Verifying..." : "Verify"}
          </button>
        </>
      )}
    </>
  );
};

export default RegisterForm;